import type { PropsWithChildren } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAppSelector } from '@/hooks/redux'
import { buildLoginUrlWithRedirect } from '@/lib/postLoginRedirect'

export const ProtectedRoute = ({ children }: PropsWithChildren) => {
  const isAuthenticated = useAppSelector((s) => s.auth.isAuthenticated)
  const location = useLocation()

  if (!isAuthenticated) {
    return (
      <Navigate
        to={buildLoginUrlWithRedirect(
          location.pathname,
          location.search,
          location.hash,
        )}
        replace
      />
    )
  }

  return <>{children}</>
}
